main.window = (function () {
    var isResizing = false;
    var isScrolling = false;

    var init = function () {
        _setVarsOnScroll();
        _setVarsOnResize();
        _handleScroll();
        _handleResize();
    };

    var _handleResize = function () {
        window.addEventListener('resize', _resizeListener, false);
    };

    var _resizeListener = function () {
        if (!isResizing) {
            requestAnimationFrame(_updateResize);
        }
        isResizing = true;
    };

    var _updateResize = function () {
        isResizing = false;
        _setVarsOnResize();

        main.animations.setLogoVariables();
        main.animations.animateLogo();
        main.slider.checkStatus();
    };

    var _handleScroll = function () {
        window.addEventListener('scroll', _scrollListener, false);
    };

    var _scrollListener = function () {
        if (!isScrolling) {
            requestAnimationFrame(_updateScroll);
        }
        isScrolling = true;
    };

    var _updateScroll = function () {
        isScrolling = false;
        _setVarsOnScroll();

        main.scroll.handleVisiblity();
        main.animations.animateLogo();
    };

    var _setVarsOnScroll = function () {
        main.vars.scrollY = window.pageYOffset || 0;
        main.vars.scrollPercentage = main.vars.scrollY / (main.vars.pageHeight - main.vars.windowHeight) * 100;
    };

    var _setVarsOnResize = function () {
        var html = document.documentElement;
        var body = document.body;

        main.vars.windowHeight = window.innerHeight;
        main.vars.pageHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    };

    return {
        init: init
    };
})();
